import React, { useEffect, useState } from "react";
import {
  Card,
  Button,
  Spin,
  Divider,
  Descriptions,
  Image,
  Empty,
  Modal,
  Tag,
  Grid,
} from "antd";
import {
  ArrowLeftOutlined,
  ShopOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { URL } from "../config";

export default function CustomerDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const res = await axios.get(`${URL}/customers/${id}`);
        setData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCustomer();
  }, [id]);

  const renderImages = (val) => {
    if (!val) return <Empty description="No images available" />;
    const images = Array.isArray(val) ? val : [val];

    return (
      <div
        style={{
          display: "flex",
          gap: 12,
          flexWrap: "wrap",
          justifyContent: screens.xs ? "center" : "flex-start",
        }}
      >
        {images.map((img, i) => {
          const src = img.startsWith("http") ? img : `${URL}${img}`;
          return (
            <Image
              key={i}
              src={src}
              preview={false}
              style={{
                width: screens.xs ? "100%" : 120,
                maxWidth: 180,
                height: screens.xs ? "auto" : 120,
                objectFit: "cover",
                borderRadius: 12,
                cursor: "pointer",
                boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
              }}
              onClick={() => {
                setPreviewImage(src);
                setPreviewVisible(true);
              }}
            />
          );
        })}
      </div>
    );
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 120,
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!data) return <Empty description="Customer not found" />;

  return (
    <div
      style={{
        padding: screens.xs ? 12 : 24,
        background: "#f4f6f8",
        minHeight: "100vh",
      }}
    >
      <Card
        style={{
          maxWidth: 1200,
          margin: "auto",
          borderRadius: 18,
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
        }}
      >
    
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <h2 style={{ fontWeight: 700, margin: 0 }}>
            Customer Details
          </h2>

          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>

        {/* BASIC DETAILS */}
        <Card
          title="Basic Information"
          style={{
            marginBottom: 20,
            borderRadius: 12,
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}
        >
          <Descriptions
            bordered
            column={screens.xs ? 1 : 2}
            size="small"
          >
            <Descriptions.Item label="Customer ID">
              {data.CustomerId}
            </Descriptions.Item>

            <Descriptions.Item label="Customer Name">
              {data.CustomerName || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Shop Name">
              {data.ShopName || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Mobile No">
              {data.MobileNo || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Alternate Mobile">
              {data.alternateMobileNo || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Pincode">
              {data.Pincode || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Address" span={2}>
              {data.Address || "-"}
            </Descriptions.Item>
          </Descriptions>
        </Card>

     
        <Card
          title="Service Details"
          style={{
            marginBottom: 20,
            borderRadius: 12,
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}
        >
          <Descriptions
            bordered
            column={screens.xs ? 1 : 2}
            size="small"
          >
            <Descriptions.Item label="Service Status">
              <Tag color={data.isServiceActive === 1 ? "green" : "red"}>
                {data.isServiceActive === 1 ? "Active" : "Inactive"}
              </Tag>
            </Descriptions.Item>

            <Descriptions.Item label="Service Duration">
              {data.serviceDuration || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Internet">
              {data.Internet === 1 ? "Available" : "Not Available"}
            </Descriptions.Item>

            <Descriptions.Item label="Monitoring">
              {data.Monitoring === 1 ? "Enabled" : "Disabled"}
            </Descriptions.Item>

            <Descriptions.Item label="Camera Count">
              {data.CountOfCamera || 0}
            </Descriptions.Item>
          </Descriptions>
        </Card>

       
        <Card
          title="Customer Description"
          style={{
            marginBottom: 20,
            borderRadius: 12,
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}
        >
          {data.description || "No description provided"}
        </Card>

      
        <Divider />

        <h3>
          <ShopOutlined /> Shop Images
        </h3>
        <Card style={{ marginBottom: 20 }}>
          {renderImages(data.shopImg)}
        </Card>

        <h3>
          <IdcardOutlined /> Visiting Card Images
        </h3>
        <Card>{renderImages(data.visitingCardImg)}</Card>

     
        <Modal
          open={previewVisible}
          footer={null}
          onCancel={() => setPreviewVisible(false)}
        >
          <img
            alt="preview"
            src={previewImage}
            style={{
              width: "100%",
              borderRadius: 14,
            }}
          />
        </Modal>
      </Card>
    </div>
  );
}
